import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  InputAdornment,
  TextField,
  Typography,
  styled,
} from '@mui/material';
import { ColorsV2 } from 'app/constants/color';
import apiService from 'app/services/apiService';
import { Buttons } from 'app/constants/sizing';
import { useTranslation } from 'react-i18next';

const FormContainer = styled('form')({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  gap: '20px',
  marginTop: '20px',
});

export default function CreatePolicy({ isOpen, setIsOpen, setShowToast }) {
  const withoutTemplate = useSelector(state => state.privacyPersisted.WithoutTemplate);
  const [message, setMessage] = useState('');

  const { t } = useTranslation('translation', { keyPrefix: 'policy_manager' });

  const handleClose = () => {
    setIsOpen({ ...isOpen, requestDatatype: false });
  };

  const CustomAdornment = styled(InputAdornment)({
    fontFamily: 'DM Sans, sans-serif',
    margin: '0px 5px 0px 0px',
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '21px',
    color: 'red',
  });

  const handleRequestDatatype = async () => {
    try {
      await apiService.requestDataType({
        policyTypeId: withoutTemplate.policyType,
        message,
      });
      handleClose();
      setShowToast({
        open: true,
        message: 'Requested successfully',
        severity: 'success',
      });
    } catch (error) {
      console.error(error);
    }
  };

  const handleChange = e => {
    setMessage(e.target.value);
  };
  return (
    <>
      <Dialog open={true} onClose={handleClose}>
        <Box
          sx={{
            background: ColorsV2.secondary,
            padding: '20px',
            minHeight: '25vh',
          }}
        >
          <Typography variant='h6' sx={{ color: ColorsV2.white }}>
            {t('request_datatype_menu_header')}
          </Typography>

          <DialogContent>
            <FormContainer noValidate autoComplete='off'>
              <TextField
                noValidate
                id='name'
                // value={data?.name}
                name='name'
                onChange={handleChange}
                InputProps={{
                  startAdornment: (
                    <CustomAdornment position='start'>
                      <Typography
                        sx={{
                          color: ColorsV2.white,
                          fontFamily: 'DM Sans, sans-serif',
                          fontSize: '14px',
                        }}
                      >
                        {t('datatype')}
                      </Typography>
                    </CustomAdornment>
                  ),
                  style: {
                    color: ColorsV2.white,
                    fontFamily: 'DM Sans, sans-serif',
                    fontSize: '14px',
                    fontWeight: '400',
                    lineHeight: '21px',
                    borderRadius: '8px',
                    height: '48px',
                  },
                }}
                InputLabelProps={{
                  style: {
                    color: 'inherit',
                  },
                }}
                sx={{
                  ...Buttons.baseStyle.textFieldLowPriority,
                }}
              />

              <Button disabled={!message} name='IconButton' onClick={handleRequestDatatype} 
              sx={{ 
                ...Buttons.baseStyle.primaryButtonHighPriority, 
                maxWidth: '160px', 
                alignSelf: 'flex-end'}}
              >
                {t('request_datatype_menu_confirm')}
              </Button>
            </FormContainer>
          </DialogContent>
        </Box>
      </Dialog>
    </>
  );
}
